export const getUAgent = () => window.navigator.userAgent;
/*
export enum EDevicePlatform {
    iPhone = 'iPhone',
}

const platform:EDevicePlatform = window.navigator.platform*/

export const isWXMiniProgram = () => window.__wxjs_environment === 'miniprogram' || getUAgent().match(/miniProgram/i)
export const isIOS = () => getUAgent().match(/iphone/i)
export const isYIXIN = () => getUAgent().match(/yixin/i)
export const is2345 = () => getUAgent().match(/Mb2345/i)
export const ishaosou = () => getUAgent().match(/mso_app/i)
export const isSogou = () => getUAgent().match(/sogoumobilebrowser/ig)
export const isLiebao = () => getUAgent().match(/liebaofast/i)
export const isGnbr = () => getUAgent().match(/GNBR/i)
export const isWeChat = () => !isWXMiniProgram() && getUAgent().match(/MicroMessenger/i)
export const isWeiBo = () => getUAgent().match(/weibo/i)
export const isQQ = () => getUAgent().match(/qqbrowser/i)
export const isQQInner = () => getUAgent().match(/qqbrowser/i) && getUAgent().match(/\sqq/i)
export const isOS = () => getUAgent().match(/os\s+5/i)
export const isBaidu = () => getUAgent().match(/baidu/i)
export const isUC = () => getUAgent().match(/ucbrowser/i)
export const isWindows = () => getUAgent().match(/windows/i)
export const isAndroid = () => getUAgent().match(/android/i)

